import React from 'react'
import Pagination from './Pagination'
import { selectHouseByHouse,selectPage, selectTotalCount, selectTotalPages } from '../../../reducers/houseByHouseReducer';
import Row from "../Row";
import { useDispatch, useSelector } from 'react-redux';
import { fetchHouseByHouse } from '../../../fetch/search';
import { selectLangObj } from '../../../reducers/langReducer';

export default function HouseByHousePagination({term}) {

    const housebyhouse = useSelector(selectHouseByHouse);
    const page = useSelector(selectPage);
    const count = useSelector(selectTotalCount);
    const totalPages = useSelector(selectTotalPages);
    const dispatch = useDispatch();
    const langObj = useSelector(selectLangObj);

    var getItems = e => {

        return housebyhouse.map(a=>{ 
          

          return (<Row isOnPhoto={a.hasPicture} hasOptions={true} optionsType={"П"} id={a.rbrPopulacija} photo={a.documentId} title={(a.име||"") +(a.имеОца?" ("+a.имеОца+") ":" ")+ (a.презиме||"")} text={a.годРођења && (a.годРођења + (a.годСмрти?(" - "+a.годСмрти):"")) || ""}></Row>)


        });

      }

  return (
    <Pagination title={langObj["Household"]} onPageSet={(e)=>{

      dispatch(fetchHouseByHouse({param:term, page:e}));


  }} count={count} items={getItems()} pagenum={page} totalpages={totalPages} />
  )
}
